import { getStateIfFn } from 'as-ui-kit/utils/reducers';
import { docs } from 'as-ui-kit/const/api';

export const getApiPrefix = getState => {
    const state = getStateIfFn(getState);
    return state?.app?.apiUrlPrefix || '';
};

export const getDocsApiPrefix = getState => {
    const state = getStateIfFn(getState);
    return state?.app ? state.app.docsApiUrl + docs.next : '';
};

export const getSiteFeatures = getState => {
    const state = getStateIfFn(getState);
    return state?.app?.siteFeatures || {};
};

export const getAtiId = getState => {
    const state = getStateIfFn(getState);
    const account = state.account;

    return account.accountId || account.firmId;
};
